<div class="footer-holder">
  <div class="copyright">&copy; 2025 - INOBU AB</div>
</div>
